import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import {
  Table as TableMUI,
  TableBody,
  TableCell,
  TableContainer as TableContainerMUI,
  TableRow as TableRowMUI,
} from '@material-ui/core';
import devices from '../styles/devices';

const TableContainer = styled(TableContainerMUI)`
  background: transparent;
  height: 413px;
  overflow: auto;
`;
const Table = styled(TableMUI)`
  .MuiTableCell-root {
    padding: 0 11px;
    border-bottom: none;
  }
  .MuiTableCell-body {
    color: ${({ theme }) => theme.colors.gray400};
  }
`;
const TableRow = styled(TableRowMUI)`
  height: 59px;

  &:nth-of-type(odd) {
    background: ${({ theme }) => theme.colors.gray600};
  }

  & > td.MuiTableCell-root {
    padding-top: ${({ mobile }) => mobile && '13px'};
    padding-bottom: ${({ mobile }) => mobile && '13px'};
    &:first-child {
      padding-left: ${({ mobile }) => mobile && '21px'};
    }
    &:last-child {
      padding-right: ${({ mobile }) => mobile && '21px'};
    }
  }
  @media (max-width: ${devices.tablet}) {
    display: ${({ mobile }) => !mobile && 'none !important'};
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4),
    &:nth-child(5),
    &:nth-child(6),
    &:nth-child(7) {
      display: table-row !important;
    }
  }
`;
const CellContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const Name = styled.p`
  font-size: 0.75rem;
  font-weight: 700;
`;
const TransactionDate = styled.p`
  font-size: 0.75rem;
`;
const Value = styled.p`
  font-size: 0.9375rem;
  white-space: nowrap;
`;

export default function MonetaryTable({ data, children, mobile, ariaLabel }) {
  return (
    <TableContainer>
      <Table aria-label={ariaLabel}>
        <TableBody>
          {data?.map(row => (
            <TableRow key={row.dateTime} mobile={mobile} type={row.type}>
              <TableCell>
                <CellContent>
                  <Name>{row.description}</Name>
                  <TransactionDate>
                    {moment(row.dateTime).calendar(null, {
                      sameDay: '[hoje]',
                      lastDay: '[ontem]',
                      lastWeek: 'dddd',
                      sameElse: 'DD/MM/YYYY',
                    })}{' '}
                    - {moment(row.dateTime).format('HH:mm:ss')}
                  </TransactionDate>
                </CellContent>
              </TableCell>
              <TableCell align="right">
                <Value style={{ color: row?.type === 'crédito' && 'green' }}>
                  {row?.type === 'crédito' ? '+' : '-'} {row.value?.toBRL()}
                </Value>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {children}
    </TableContainer>
  );
}

MonetaryTable.propTypes = {
  data: PropTypes.array,
  children: PropTypes.any,
  mobile: PropTypes.bool,
  ariaLabel: PropTypes.string,
};
